import { render, staticRenderFns } from "./PriceListModalForm.vue?vue&type=template&id=774920d3&scoped=true"
import script from "./PriceListModalForm.vue?vue&type=script&lang=js"
export * from "./PriceListModalForm.vue?vue&type=script&lang=js"
import style0 from "./PriceListModalForm.vue?vue&type=style&index=0&id=774920d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774920d3",
  null
  
)

export default component.exports